import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const getReadbleDate = (format?: string) =>
  (date: Dayjs | Date | string) =>
    dayjs(date, format).format("MM/DD/YYYY");